// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__6RHCQ","layout":"_styles_layout__ae+P0","layout_content":"_styles_layout_content__UqtlY"};